import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Wholesale() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'الكل' },
    { id: 'groceries', name: 'بقالات' },
    { id: 'beverages', name: 'مشروبات' },
    { id: 'cleaning', name: 'منظفات' }
  ];

  const products = [
    {
      id: 1,
      name: 'أرز بسمتي - كرتون 10 كجم × 4',
      price: 160,
      oldPrice: 200,
      minQuantity: 5,
      image: 'https://public.readdy.ai/ai/img_res/5a4425f397cb1df5c9c12996d8c82d6d.jpg',
      category: 'groceries',
      discount: '20%'
    },
    {
      id: 2,
      name: 'زيت زيتون - كرتون 12 زجاجة',
      price: 950,
      oldPrice: 1100,
      minQuantity: 3,
      image: 'https://readdy.ai/api/search-image?query=wholesale%20olive%20oil%20bottles%20carton%2C%20bulk%20packaging%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20commercial%20photo&width=200&height=200&seq=w2&orientation=squarish',
      category: 'groceries',
      discount: '14%'
    },
    {
      id: 3,
      name: 'مياه معدنية - كرتون 24 زجاجة',
      price: 18,
      minQuantity: 10,
      image: 'https://readdy.ai/api/search-image?query=wholesale%20water%20bottles%20carton%20pack%2C%20bulk%20packaging%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20commercial%20photo&width=200&height=200&seq=w3&orientation=squarish',
      category: 'beverages'
    },
    {
      id: 4,
      name: 'مسحوق غسيل - كرتون 6 عبوات',
      price: 185,
      oldPrice: 220,
      minQuantity: 4,
      image: 'https://readdy.ai/api/search-image?query=wholesale%20detergent%20powder%20carton%2C%20bulk%20packaging%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20commercial%20photo&width=200&height=200&seq=w4&orientation=squarish',
      category: 'cleaning',
      discount: '16%'
    }
  ];

  const filteredProducts = products.filter(p => 
    selectedCategory === 'all' || p.category === selectedCategory
  );

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-20" style={{ fontFamily: 'Cairo, sans-serif' }}>
      {/* Top Navigation */}
      <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-[#FF8F00] to-[#F57C00] z-50 shadow-lg">
        <div className="px-4 py-4 flex items-center gap-3">
          <button onClick={() => navigate('/home')} className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-2xl"></i>
          </button>
          <div className="flex-1">
            <h1 className="text-white text-lg font-bold">طلبات الجملة</h1>
            <p className="text-white/90 text-xs">أسعار خاصة للتجار</p>
          </div>
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-box-3-fill text-white text-xl"></i>
          </div>
        </div>

        {/* Categories */}
        <div className="px-4 pb-3 overflow-x-auto scrollbar-hide">
          <div className="flex gap-2">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setSelectedCategory(cat.id)}
                className={`px-5 py-2 rounded-full whitespace-nowrap font-medium text-sm transition-all ${
                  selectedCategory === cat.id
                    ? 'bg-white text-[#FF8F00] shadow-lg'
                    : 'bg-white/20 text-white'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="pt-32 px-4">
        {/* Info Banner */}
        <div className="bg-gradient-to-r from-[#0D47A1]/10 to-[#1976D2]/10 border border-[#0D47A1]/20 rounded-2xl p-4 mb-4 flex items-start gap-3">
          <i className="ri-information-fill text-[#0D47A1] text-xl flex-shrink-0 mt-0.5"></i>
          <div>
            <h3 className="text-[#212121] font-bold text-sm mb-1">شروط طلبات الجملة</h3>
            <ul className="text-gray-600 text-xs leading-relaxed space-y-1">
              <li>• الحد الأدنى للطلب حسب كل منتج</li>
              <li>• أسعار خاصة للكميات الكبيرة</li>
              <li>• توصيل مجاني للطلبات فوق 1000 ر.س</li>
            </ul>
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-2 gap-3" data-product-shop>
          {filteredProducts.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-2xl overflow-hidden shadow-sm"
            >
              <div className="relative h-44 bg-gray-100">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover object-top" />
                {product.discount && (
                  <div className="absolute top-2 left-2 bg-[#FF8F00] text-white text-xs font-bold px-2 py-1 rounded-full">
                    خصم {product.discount}
                  </div>
                )}
                <div className="absolute top-2 right-2 bg-[#0D47A1] text-white text-xs font-bold px-2 py-1 rounded-full">
                  جملة
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-[#212121] text-sm font-bold mb-2 text-right line-clamp-2 h-10">{product.name}</h3>
                
                <div className="bg-[#F6F6F6] rounded-lg p-2 mb-3">
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-gray-600">الحد الأدنى</span>
                    <span className="text-[#212121] font-bold">{product.minQuantity} كرتون</span>
                  </div>
                </div>

                <div className="flex items-center justify-between mb-3">
                  <div>
                    <div className="text-[#FF8F00] text-lg font-bold">{product.price} ر.س</div>
                    {product.oldPrice && (
                      <div className="text-gray-400 text-xs line-through">{product.oldPrice} ر.س</div>
                    )}
                  </div>
                </div>

                <button
                  onClick={() => navigate('/quotes')}
                  className="w-full bg-gradient-to-r from-[#FF8F00] to-[#F57C00] text-white py-2.5 rounded-xl font-bold text-sm active:scale-95 transition-transform"
                >
                  طلب الآن
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
        <div className="grid grid-cols-5 h-16">
          <button onClick={() => navigate('/home')} className="flex flex-col items-center justify-center gap-1">
            <i className="ri-home-5-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">الرئيسية</span>
          </button>
          <button onClick={() => navigate('/products')} className="flex flex-col items-center justify-center gap-1">
            <i className="ri-grid-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">المنتجات</span>
          </button>
          <button onClick={() => navigate('/cart')} className="flex flex-col items-center justify-center gap-1 relative">
            <i className="ri-shopping-cart-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">السلة</span>
            <span className="absolute top-1 right-1/2 translate-x-3 w-4 h-4 bg-[#FF8F00] text-white text-[0.5rem] font-bold rounded-full flex items-center justify-center">3</span>
          </button>
          <button onClick={() => navigate('/orders')} className="flex flex-col items-center justify-center gap-1">
            <i className="ri-file-list-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">الطلبات</span>
          </button>
          <button onClick={() => navigate('/profile')} className="flex flex-col items-center justify-center gap-1">
            <i className="ri-user-line text-gray-400 text-xl"></i>
            <span className="text-gray-400 text-[0.625rem]">الحساب</span>
          </button>
        </div>
      </div>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
}